import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchInvoices(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/invoices', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchInvoice(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/invoices/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createInvoice(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/invoices/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addInvoice(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/invoices`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteInvoice(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/invoices/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateInvoice(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/invoices/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchEnrollments(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/enrollments', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchStudents(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/students', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        sendEmail(ctx, data)  {
            return new Promise((resolve, reject) =>
            {
              axios
                  .post('/send-invoice',  data)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        },
        downloadInvoice(ctx, data)  {
            return new Promise((resolve, reject) =>
            {
              axios
                  .post('/download-invoice',  data,{ responseType: 'arraybuffer' })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        },

        downloadReceipt(ctx, data)  {
            return new Promise((resolve, reject) =>
            {
              axios
                  .post('/download-receipt',  data,{ responseType: 'arraybuffer' })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        },

        convertIntoInvoice(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/convert-invoice/${data.id}`, {params:data})
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }





    }
}
